import { 
    FETCH_SITUACION_IVA, 
    FETCH_TIPOS_ADQUIRIENTES, 
    FETCH_TIPOS_SEXO, 
    FETCH_TIPOS_CONCEPTOS, 
    LOADING_TIPOS_CONCEPTOS
} from './types';
import {
    getSituacionIva, 
    getTiposAdquirientes, 
    getTiposSexo, 
    getTiposConceptosApi 
} from "../api/axios";
import { extractConceptosNovedadesRawList } from '../utilities/Novedades/extractConceptosNovedadesRawList';

export const fetchSituacionIva = () => async dispatch => { // ESTE MÉTODO NO SE USA EN NINGUN COMPONENTE
    let array = getSituacionIva();
    array.then((value) => {
        dispatch({
            type: FETCH_SITUACION_IVA,
            payload: value.tiposIva
        });
    })
}

export const fetchTiposAdquirientes = () => async dispatch => {
    let array = getTiposAdquirientes();
    array.then((value) => {
        dispatch({
            type: FETCH_TIPOS_ADQUIRIENTES,
            payload: value.tiposAdquirientes
        });
    })
}

export const fetchTiposSexo = () => async dispatch => { // ESTE MÉTODO NO SE ESTÁ USANDO DESDE NINGUN COMPONENTE
    let array = getTiposSexo();
    array.then((value) => {
        dispatch({
            type: FETCH_TIPOS_SEXO,
            payload: value.tipoSexo
        });
    })
}

export const fetchListaConceptos = () => async dispatch => {
    
    dispatch({
        type: LOADING_TIPOS_CONCEPTOS,
        payload: true
    });

  getTiposConceptosApi().then((value) => {
    const rawList = extractConceptosNovedadesRawList(value);

    const normalizedList = rawList.map((item) => ({
      ...item,
      idConcepto: item?.idConcepto ?? item?.IdConcepto ?? item?.concepto ?? item?.Concepto ?? item?.id ?? item?.Id ?? item?.codigo ?? item?.Codigo ?? "",
      idTipoNovedad: item?.idTipoNovedad ?? item?.IdTipoNovedad ?? item?.idAccion ?? item?.IdAccion ?? item?.accion?.id ?? item?.Accion?.Id ?? 0,
      idSubTipo: item?.idSubTipo ?? item?.IdSubTipo ?? item?.idTipoNovedad ?? item?.IdTipoNovedad ?? item?.idAccion ?? item?.IdAccion ?? 0,
      detalleConcepto: item?.detalleConcepto ?? item?.DetalleConcepto ?? item?.concepto ?? item?.Concepto ?? item?.descripcion ?? item?.Descripcion ?? "",
      descripcionSubTipoNovedad: item?.descripcionSubTipoNovedad ?? item?.DescripcionSubTipoNovedad ?? item?.descripcionSubTipo ?? item?.DescripcionSubTipo ?? item?.accion?.descripcion ?? item?.Accion?.Descripcion ?? item?.descripcion ?? item?.Descripcion ?? "",
      mostrarBotonEliminar: item?.mostrarBotonEliminar ?? item?.MostrarBotonEliminar ?? true
    }));

    const normalizedValue = {
      ...value,
      listaConceptoNovedades: normalizedList
    }
    const conceptos = normalizedValue?.listaConceptoNovedades ?? normalizedValue?.conceptos ?? normalizedValue?.tiposNovedades ?? normalizedValue?.data?.tiposNovedades ?? normalizedValue?.data?.listaConceptoNovedades ?? normalizedValue?.elementos ?? [];

    dispatch({
      type: LOADING_TIPOS_CONCEPTOS,
      payload: false
    });

    dispatch({
      type: FETCH_TIPOS_CONCEPTOS,
      payload: conceptos
    });
  }).catch(() => {
        dispatch({
            type: LOADING_TIPOS_CONCEPTOS,
            payload: false
        });
        dispatch({
            type: FETCH_TIPOS_CONCEPTOS,
            payload: []
        });
    })
}

export const getTiposConceptos = async () => {
  const result = await getTiposConceptosApi();
  const rawList = extractConceptosNovedadesRawList(result);

  const normalizedList = rawList.map((item) => ({
    ...item,
    idConcepto: item?.idConcepto ?? item?.IdConcepto ?? item?.concepto ?? item?.Concepto ?? item?.id ?? item?.Id ?? item?.codigo ?? item?.Codigo ?? "",
    idTipoNovedad: item?.idTipoNovedad ?? item?.IdTipoNovedad ?? item?.idAccion ?? item?.IdAccion ?? item?.accion?.id ?? item?.Accion?.Id ?? 0,
    idSubTipo: item?.idSubTipo ?? item?.IdSubTipo ?? item?.idTipoNovedad ?? item?.IdTipoNovedad ?? item?.idAccion ?? item?.IdAccion ?? 0,
    detalleConcepto: item?.detalleConcepto ?? item?.DetalleConcepto ?? item?.concepto ?? item?.Concepto ?? item?.descripcion ?? item?.Descripcion ?? "",
    descripcionSubTipoNovedad: item?.descripcionSubTipoNovedad ?? item?.DescripcionSubTipoNovedad ?? item?.descripcionSubTipo ?? item?.DescripcionSubTipo ?? item?.accion?.descripcion ?? item?.Accion?.Descripcion ?? item?.descripcion ?? item?.Descripcion ?? "",
    mostrarBotonEliminar: item?.mostrarBotonEliminar ?? item?.MostrarBotonEliminar ?? true
  }));

  return {
    ...result,
    listaConceptoNovedades: normalizedList
  }
}
